// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
/* vee-validate */
import VeeValidate, { Validator } from 'vee-validate'
import ko from 'vee-validate/dist/locale/ko'
import VueYoutube from 'vue-youtube'
import axios from 'axios'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* local setting */
// var local = require('../vue.config.local.js')
import local from '../vue.config.local.js'
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueYoutube)

// todo
// cssVars()

// VeeValidate 설정
ko.messages.email = `이메일로 올바르게 작성해 주세요!`
ko.messages.name = `이름을 올바르게 작성해 주세요!`
ko.messages.required = `이 항목은 꼭 작성해 주셔야 합니다!`
const veeConfig = {
  locale: 'ko',
  dictionary: {
    ko
  },
  fieldsBagName: 'formFields'
}
Vue.use(VeeValidate, veeConfig)
const veeDict = {
  ko: {
    attributes: {
      email: '이메일',
      nameKr: '한글 이름',
      nameEn: 'English Name',
      mobile: '핸드폰',
      age: '기수'
    }
  }
}
Validator.localize(veeDict)

Vue.use(BootstrapVue)
store.commit('setApiServer', local.apiServer)

/* set auth list */
axios.get(store.state.APISERVER + '/admin/authlist')
  .then(response => {
    store.commit('setAuthList', response.data)
  })
  .catch(error => {
    console.log(error)
  })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})
